import {Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subscription} from 'rxjs';

import * as fromApp from '../../store/app.reducers';
import * as fromSpecialOffer from '../store/special-offer.reducers';
import * as SpecialOfferActions from '../store/special-offer.actions';
import {SpecialOfferModel} from '../special-offer.model';
import {SpecialOfferService} from '../special-offer.service';
import {PaymentService} from '../../payment/payment.service';
import {tap} from 'rxjs/operators';
import * as fromUser from '../../user/store/user.reducers';

@Component({
    selector: 'app-special-offer-popup',
    templateUrl: './special-offer-popup.component.html',
    styleUrls: ['./special-offer-popup.component.scss'],
    standalone: false
})
export class SpecialOfferPopupComponent implements OnInit, OnDestroy {

  specialOfferState: Observable<fromSpecialOffer.State>;
  specialOfferSubscription: Subscription;
  @ViewChild('content', {static: true}) modal: ElementRef;
  loadedModal = false;
  specialOffer: SpecialOfferModel;

  constructor(
    public store: Store<fromApp.AppState>,
    private modalService: NgbModal,
    private specialOfferService: SpecialOfferService,
    private paymentService: PaymentService
  ) { }

  ngOnInit() {
    this.specialOfferState = this.store.select('specialOffer');
    this.store.dispatch(
      new SpecialOfferActions.GetSpecialOfferActual()
    );
    this.specialOfferSubscription = this.store.select('specialOffer').subscribe(
      (state: fromSpecialOffer.State) => {
        if (!this.loadedModal && state.actualOffer !== null && !this.specialOfferService.checkSpecialOfferCloseState(state.actualOffer.id)) {
          this.open();
          this.loadedModal = true;
          this.specialOffer = state.actualOffer;
        } else {
          setTimeout(() => {
            if (this.specialOffer === undefined) {
              this.redirectAfterPayment();
            }
          }, 5000);
        }
      }
    );
  }

  onUseSpecialOffer() {
    this.store.dispatch(
      new SpecialOfferActions.UseSpecialOffer(this.specialOffer.id)
    );
    this.modalService.dismissAll();
  }

  open() {
    this.modalService.open(this.modal, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      console.log('close modal');
    }, (reason) => {
      this.specialOfferService.setSpecialOfferCloseState(this.specialOffer.id, true);
      this.redirectAfterPayment();
    });
  }

  redirectAfterPayment() {
    const us = this.store.select('user').subscribe(
      (userState: fromUser.State) => {
        this.paymentService.redirectAfterPayment(userState);
      }
    );
  }

  countTimeDistance() {
    const startTime = new Date().getTime() / 1000;
    const endTime = this.specialOffer.end_date;

    return parseInt((endTime - startTime).toString());
  }

  ngOnDestroy() {
    this.specialOfferSubscription.unsubscribe();
  }

}
